import React from "react";
import { useNavigate } from "react-router-dom";
import "./Docs.css";
import {
  UnauthorisedPageSurface,
  PageWrapper,
} from "../components/layout/container/Container";

const MemberTermsAndConditions = () => {
  document.title = "Katch | Terms & Conditions";

  const navigateTo = useNavigate();

  return (
    <UnauthorisedPageSurface>
      <PageWrapper>
        <section className={"docs__section"}>
          <h1>Member Terms and Conditions</h1>
          <p>Last updated: February 26th, 2026</p>
          <br />

          <p>
            These Terms and Conditions ("Terms") govern your use of Katch.one,
            an online video streaming platform ("Service") operated by
            Katch.one. By accessing or using our Service, including free and
            paid features, you agree to comply with and be bound by these Terms.
            Please read them carefully before using the Service.
          </p>

          <br />

          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using the Service, including any paid features or
            subscriptions, you agree to these Terms. If you do not agree to any
            part of these Terms, you must not access or use the Service.
          </p>
          <br />

          <h2>2. Registration</h2>
          <p>
            <strong>2.1.</strong> To access certain features, you must register
            for an account. You agree to provide accurate, current, and complete
            information during registration.
          </p>
          <p>
            <strong>2.2.</strong> You are responsible for maintaining the
            confidentiality of your account credentials and for all activities
            that occur under your account.
          </p>
          <p>
            <strong>2.3.</strong> You must be at least 13 years old to register
            for an account.
          </p>
          <br />

          <h2>3. Member Account & Paid Features</h2>
          <p>
            <strong>3.1.</strong> As a member, you can access free content and
            participate in paid features, which may include subscriptions,
            rentals, premium talent profiles, live streams, or other exclusive
            content.
          </p>
          <p>
            <strong>3.2.</strong> Pricing for paid features is determined by
            Katch.one and/or the respective content creators. Paid features are
            only accessible after successful payment and account verification.
          </p>
          <p>
            <strong>3.3.</strong> Access to paid features is limited to your
            subscription period or purchase, and you may lose access if your
            subscription is canceled or your account is terminated.
          </p>
          <br />

          <h2>4. Use of Content</h2>
          <p>
            <strong>4.1.</strong> All content on Katch.one, including free and
            paid features, is for personal, non-commercial use only.
          </p>
          <p>
            <strong>4.2.</strong> You may not download, copy, reproduce,
            distribute, transmit, broadcast, display, sell, license, or exploit
            any content on Katch.one without prior written consent from
            Katch.one or the content owner.
          </p>
          <p>
            <strong>4.3.</strong> You agree not to infringe upon the
            intellectual property rights of Katch.one or any third party.
          </p>
          <br />

          <h2>5. Prohibited Activities</h2>
          <p>
            <strong>5.1.</strong> You agree not to use the Service for unlawful
            purposes or in violation of these Terms.
          </p>
          <p>
            <strong>5.2.</strong> You may not use automated systems or software
            to extract data from the Service without prior written consent from
            Katch.one.
          </p>
          <p>
            <strong>5.3.</strong> You may not interfere with the proper
            functioning of the Service or attempt to bypass security measures.
          </p>
          <p>
            <strong>5.4.</strong> Paid features must not be shared, resold, or
            accessed by non-members without authorization.
          </p>
          <br />

          <h2>6. Payment and Billing</h2>
          <p>
            <strong>6.1.</strong> Payment for subscriptions, rentals, or other
            paid features must be made using the payment methods accepted by
            Katch.one.
          </p>
          <p>
            <strong>6.2.</strong> By providing payment details, you authorize
            Katch.one to charge the specified amount to your chosen payment
            method.
          </p>
          <p>
            <strong>6.3.</strong> All payments are non-refundable, except as
            required by law or with prior approval from Katch.one.
          </p>
          <p>
            <strong>6.4.</strong> Access to paid features may be suspended if
            payment fails or your account is flagged for suspicious activity.
          </p>
          <br />

          <h2>7. Termination</h2>
          <p>
            <strong>7.1.</strong> Katch.one reserves the right to terminate or
            suspend your account and access to free or paid features at any time
            without notice, for reasons including but not limited to violation
            of these Terms.
          </p>
          <p>
            <strong>7.2.</strong> Upon termination, your access to the Service
            and any paid features will immediately cease.
          </p>
          <br />

          <h2>8. Changes to Terms</h2>
          <p>
            <strong>8.1.</strong> Katch.one may modify or update these Terms at
            any time without prior notice. Changes will take effect immediately
            upon posting.
          </p>
          <p>
            <strong>8.2.</strong> Your continued use of the Service, including
            paid features, after changes are posted constitutes acceptance of
            the updated Terms.
          </p>
          <br />

          <h2>9. Governing Law</h2>
          <p>
            <strong>9.1.</strong> These Terms are governed by the laws of
            Australia, without regard to its conflict of laws principles.
          </p>
          <p>
            <strong>9.2.</strong> Any disputes related to these Terms or the
            Service will be subject to the exclusive jurisdiction of the courts
            in Victoria, Australia.
          </p>
          <br />

          <p>
            By accessing or using the Service, you confirm that you have read,
            understood, and agree to be bound by these Terms. If you have any
            questions, contact us at{" "}
            <a
              style={{
                color: "skyblue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigateTo("/support")}
            >
              support
            </a>
            .
          </p>
        </section>
      </PageWrapper>
    </UnauthorisedPageSurface>
  );
};

export default MemberTermsAndConditions;
